var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16471 15.5H3.3327L4.16471 9.66667H1.25269C0.770128 9.66667 0.778448 9.4 0.936529 9.11667C1.09461 8.83333 0.978129 9.05 0.994769 9.01667C2.06806 7.11667 3.68215 4.28333 5.82872 0.5H6.66072L5.82872 6.33333H8.74074C9.14842 6.33333 9.20666 6.60833 9.13178 6.75833L9.07354 6.88333C5.79544 12.625 4.16471 15.5 4.16471 15.5Z",
    fill: "#FDA536"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectric);
export default __webpack_public_path__ + "static/media/Electric.21d558269b990efb078cfe001c096864.svg";
export { ForwardRef as ReactComponent };